import { isJpPreBuild } from '@/utils/environment'

export default function TestEnvironmentBanner() {
  if (!isJpPreBuild()) return null

  return (
    <div
      role="status"
      data-testid="jp-pre-environment-banner"
      className="fixed inset-x-0 top-0 z-[100] bg-amber-400 px-3 py-1 text-center text-[11px] font-semibold text-amber-950"
    >
      JP Pre 测试环境 · 不会发送真实验证码
    </div>
  )
}
